import environment from "environment";
import type { AxiosResponse } from "axios";
import { requestService } from "../request";
import type { ExportType } from "../../components/ExportPageFd/types/ExportPageFd.types";
import type { PageToSaveType } from "../../containers/FloatingControlButtons/types/FloatingControlButtons.types";
import type { DownloadResource } from "../../components/PageSettingsResources/types/PageSettingsResources.types";

export const getPage = (id: string): Promise<unknown> => requestService
  .get(environment.endpoints.get.page.replace("{id}", id));

export const getVersionResources = (id: string): Promise<unknown> => requestService
  .get(environment.endpoints.get.resourceList.replace("{versionId}", id));

export const createPage = (data: PageToSaveType): Promise<AxiosResponse<{data: { pageId: string }}>> => requestService
  .post(environment.endpoints.post.page, data);

export const editPage = (
  data: { data: PageToSaveType },
  id: string
): Promise<unknown> => requestService
  .put(environment.endpoints.put.page.replace("{id}", id), data);

export const publishDocument = (
  data: { documentId: string }
): Promise<unknown> => requestService
  .post(environment.endpoints.post.pageVersion, data);

type PageVersionPreviewType = { data: { data: { result: { url: string } } } };

export const getPageVersionPreview = (
  pageId: string,
  versionId: string
): Promise<PageVersionPreviewType> => requestService
  .get(environment.endpoints.get.pageVersionPreview.replace("{documentId}", pageId), {
    params: { versionId },
  });

export const clonePage = (data: {
  pageId: string,
  pageName: string,
  accountId: string,
  alias?: string,
}): Promise<unknown> => requestService
  .post(environment.endpoints.post.clonePage, { ...data });

export const exportPage = (
  format: ExportType,
  ids: Array<string>,
  documentType: string
): Promise<unknown> => requestService
  .post(environment.endpoints.post.exportPage,
    {
      format,
      ids,
      documentType,
    },
    {
      responseType: "blob",
    });

export const importPage = (
  file: File,
  type: string,
  activate: boolean,
  pageType: string = "pft"
): Promise<unknown> => {
  const body = new FormData();
  body.append("documentType", pageType);
  body.append("files", file);
  body.append("activate", JSON.stringify(activate));
  body.append("type", type);
  return requestService.post(
    environment.endpoints.post.importPage,
    body,
    {
      headers: { "Content-Type": undefined },
      credentials: "include",
    } as any
  );
};

export const getJusResourcesContent = (
  accountId: string, versionId: string, resources: DownloadResource[]
): Promise<unknown> => requestService
  .post(environment.endpoints.post.downloadPageResources, { accountId, versionId, resources });
